<template>
  <a-row class="item_content">
    <a-col :span="4" class="tiitem train_no">
      <div>{{ item.trainNo }}</div>
      <div class="stopState" @click="stopShowAction(item)">
        经停站
      </div>
      <transition name="fade-transform" mode="out-in">
        <div class="box" v-show="item.stopShow">
          <div class="box_title">
            经停站<CloseCircleOutlined
              :style="{
                color: '#6D7278'
              }"
              @click="close"
            />
          </div>
          <div class="content">
            <a-row class="row_content row_title">
              <a-col span="2"></a-col>
              <a-col span="5">车站名</a-col>
              <a-col span="6">到达时间</a-col>
              <a-col span="6">发车时间</a-col>
              <a-col span="5">停留时间</a-col>
            </a-row>
            <div class="row_list_content">
              <a-skeleton active v-if="!stopStateList.length" />
              <a-row class="row_content row_list" v-for="(item, index) in stopStateList" :key="index">
                <a-col span="2">{{ item.serialNumber }}</a-col>
                <a-col span="5">{{ item.station }}</a-col>
                <a-col span="6">{{ item.arrivalTime }}</a-col>
                <a-col span="6">{{ item.departureTime }}</a-col>
                <a-col span="5">{{ item.stayTimeSpan }}</a-col>
              </a-row>
            </div>
          </div>
        </div>
      </transition>
    </a-col>
    <a-col :span="3" class="tiitem state">
      <div>{{ item.fromTime }}</div>
      <div style="font-size:14px">{{ item.fromStation }}</div>
    </a-col>
    <a-col :span="3" class="tiitem time">
      <div>{{ item.takeTimeFormat }} <img src="@assets/img/idcard.png" class="card" /></div>
      <div><img src="@assets/img/cardline.png" /></div>
    </a-col>
    <a-col :span="3" class="tiitem state">
      <div>{{ item.toTime }}</div>
      <div style="font-size:14px">{{ item.toStation }}</div>
    </a-col>
    <a-col :span="4" class="tiitem seatList" style="font-size:14px;font-family: PingFangSC-Medium, PingFang SC;">
      <div v-for="(data, dataIndex) in item.tickets" :key="dataIndex">
        {{ data.seatName }}<span>¥{{ data.price }}</span>
      </div>
    </a-col>
    <a-col
      :span="3"
      class="tiitem seatList"
      style="font-size:14px;font-family: PingFangSC-Light, PingFang SC;font-weight: 300;"
    >
      <div v-for="(data, dataIndex) in item.tickets" :key="dataIndex">
        <span v-if="data.seatNumber < 21 && data.seatNumber > 0" style="color:#FD5739"
          ><span style="color:#000">余</span>{{ data.seatNumber }}<span style="color:#000">张</span></span
        >
        <span v-else style="color:#000">{{ data.seatNumber >= 21 ? "有票" : "无票" }}</span>
      </div>
    </a-col>
    <a-col :span="4" class="tiitem seatList">
      <div v-for="(data, dataIndex) in item.tickets" :key="dataIndex">
        <a-button
          type="primary"
          v-show="data.seatNumber == 0 && !endorse"
          class="nomtbtn"
          size="small"
          @click="toRob(item, data.seatType)"
        >
          抢票
        </a-button>

        <a-button type="primary" v-show="data.seatNumber == 0 && endorse" class="disbtn" size="small">
          无票
        </a-button>

        <a-button
          type="primary"
          v-show="data.seatNumber != 0"
          class="mtbtn"
          size="small"
          @click="toSubmitOrder(data.seatType)"
        >
          {{ data.seatNumber == 0 ? "无票" : endorse ? "改签" : "预定" }}
        </a-button>
      </div>
    </a-col>
  </a-row>
</template>
<script>
import { useRouter, useRoute } from "vue-router";
import { Modal } from "ant-design-vue";
import homeApi from "@axios/home";
import { ref } from "vue";
import format from "@assets/js/format";
import { CloseCircleOutlined } from "@ant-design/icons-vue";

export default {
  componentname: "listItem",
  components: {
    CloseCircleOutlined
  },
  props: {
    item: {
      type: Object,
      default: function() {
        return {};
      }
    },
    fromStation: {
      type: String,
      default: ""
    },
    toStation: {
      type: String,
      default: ""
    },
    choseDate: {
      type: String,
      default: ""
    },
    endorse: {
      type: String,
      default: ""
    }
  },
  setup(props, { emit }) {
    const router = useRouter();
    const route = useRoute();

    const toSubmitOrder = (type) => {
      if (route.query.endorse) {
        if (props.item.fromStation == props.fromStation && props.item.toStation == props.toStation) {
          router.push({
            name: "submitOrder",
            query: {
              seatType: type,
              fromStation: props.item.fromStation,
              toStation: props.item.toStation,
              choseDate: props.choseDate,
              trainNo: props.item.trainNo,
              endorse: props.endorse
            }
          });
        } else {
          Modal.confirm({
            title: `请确认原订单（${props.fromStation} - ${props.toStation})`,
            content: `改签成（${props.item.fromStation} - ${props.item.toStation}）`,
            onOk() {
              router.push({
                name: "submitOrder",
                query: {
                  seatType: type,
                  fromStation: props.item.fromStation,
                  toStation: props.item.toStation,
                  choseDate: props.choseDate,
                  trainNo: props.item.trainNo,
                  endorse: props.endorse
                }
              });
            },
            cancelText: "取消",
            okText: "确定",
            onCancel() {
              Modal.destroyAll();
            }
          });
        }
      } else {
        router.push({
          name: "submitOrder",
          query: {
            seatType: type,
            fromStation: props.item.fromStation,
            toStation: props.item.toStation,
            choseDate: props.choseDate,
            trainNo: props.item.trainNo,
            endorse: props.endorse
          }
        });
      }
    };

    const toRob = (item, seat) => {
      localStorage.setItem("rob", JSON.stringify(item));
      router.push({
        name: "rob",
        query: {
          choseDate: props.choseDate,
          seat: seat
        }
      });
    };

    let stopStateList = ref([]);

    const stopShowAction = (item) => {
      let params = {
        trainNo: item.trainNo,
        fromStation: item.fromStation,
        toStation: item.toStation,
        trainDate: format.formatDate1(props.choseDate)
        // trainCode: item.trainLongNo
      };
      emit("stopShow", item.trainNo);
      homeApi.trainStopStation(params).then((res) => {
        stopStateList.value = res.stations;
      });
    };

    const close = () => {
      emit("close");
    };

    return {
      close,
      stopStateList,
      stopShowAction,
      toRob,
      toSubmitOrder
    };
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.box_title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  display: flex;
  justify-content: space-between;
  border-bottom: 3px solid #cdcccd;
  padding-bottom: 6px;
}
.title {
  color: #fff;
  font-size: 20px;
}
.content {
  // padding:26px 20px;
  margin-top: 11px;
}
.row_list_content {
  max-height: 400px;
  overflow-y: auto;
}
.row_content {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  text-align: center;
}
.row_list {
  margin-bottom: 8px;
}
.row_title {
  margin-bottom: 11px;
}
.nomtbtn {
  background: #0d6dbf;
  border-radius: 5px;
  border-color: #0d6dbf;
  width: 60px;
  height: 24px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
}
.disbtn {
  background: #aaa;
  border-radius: 5px;
  border-color: #aaa;
  width: 60px;
  height: 24px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  cursor: not-allowed;
}
.mtbtn {
  background: #ffab00;
  border-radius: 5px;
  border-color: #ffab00;
  width: 60px;
  height: 24px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
}
.train_no {
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  position: relative;
  .stopState {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3999fb;
    text-decoration: underline;
    cursor: pointer;
  }
  .box {
    width: 430px;
    background: #fff;
    border: 0.5px solid #cdcccd;
    padding: 26px 13px;
    position: absolute;
    z-index: 10;
    left: 80px;
    top: 55px;
  }
}
.item_content {
  padding: 38px 0;
  border-bottom: 0.5px solid #cdcccd;
  display: flex;
  align-items: center;
}
.tiitem {
  text-align: center;
  font-family: PingFangSC-Medium, PingFang SC;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.state {
  flex-direction: column;
  font-size: 20px;
}
.time {
  font-family: PingFangSC-Light, PingFang SC;
  flex-direction: column;
  font-size: 14px;
  img {
    width: 85px;
  }
  .card {
    width: 20px;
    position: relative;
    top: -1px;
  }
}
.seatList {
  flex-direction: column;
  font-size: 14px;
  div {
    margin-bottom: 3px;
    margin-top: 3px;
    line-height: 28px;
    span {
      margin: 0 7px;
      color: #ff6912;
    }
  }
}
</style>
